import React, { Fragment } from 'react';
import CopyButton from '@uiParts/copyButton';

const EXTEND_CASELIST_PLACEHOLDERS: { name: string; value: string }[] = [
  { name: '案件.案件分類', value: '#案件.案件分類#' },
  { name: '案件.優先度', value: '#案件.優先度#' },
  { name: '案件.系統名', value: '#案件.系統名#' },
  { name: '案件.フロア', value: '#案件.フロア#' },
  { name: '案件.部屋', value: '#案件.部屋#' },
  { name: '案件.担当者', value: '#案件.担当者#' },
  { name: '案件.設備名', value: '#案件.設備名#' },
  { name: '案件.設備種別', value: '#案件.設備種別#' },
  { name: '案件.設備科目', value: '#案件.設備科目#' },
  { name: '案件.対応履歴', value: '#案件.対応履歴#' },
];

/**
 * extend-create-caselist プラグインが追加するプレースホルダー行
 * monthlyReport.format.placeholders 拡張ポイント経由で table > tbody 内にレンダリングされる
 */
const ExtendCaselistPlaceholders: React.FC = () => {
  const pairs = [];
  for (let i = 0; i < EXTEND_CASELIST_PLACEHOLDERS.length; i += 2) {
    pairs.push(EXTEND_CASELIST_PLACEHOLDERS.slice(i, i + 2));
  }

  return (
    <>
      {pairs.map((pair, i) => (
        <tr key={`extend-caselist-placeholder-row-${i}`}>
          {pair.map((item, j) => (
            <Fragment key={`extend-caselist-placeholder-${i}-${j}`}>
              <th title={item.name}>{item.name}</th>
              <td className="value">
                <span className="item-box auto-select">{item.value}</span>
              </td>
              <td className="copy">
                <CopyButton copiedText={item.value} />
              </td>
            </Fragment>
          ))}
          {pair.length === 1 && (
            <>
              <th />
              <td />
              <td />
            </>
          )}
        </tr>
      ))}
    </>
  );
};

export default ExtendCaselistPlaceholders;
